import './App.css'
import { useFetchMessages } from './useFetch'
import InsideBnPage from './pages/inside/InsideBnPage'
import InsideBnInternalPage from './pages/inside/InsideBnInternalPage1'
import LocationsPage from './pages/locations/LocationsPage'
import JobListingPage from './pages/job-listing/JobListingPage'
import JobDetailPage from './pages/detail/JobDetailPage'
import JobListingInternalPage from './pages/job-listing/JobListingInternalPage'
import JobDetailInternalPage from './pages/detail/JobDetailInternalPage'
import TestimonialsPage from './pages/testimonials/TestimonialsPage'
import HomePage from './pages/home/HomePage'
import HomeInternalPage from './pages/home/HomeInternalPage'
import LoginPage from './pages/login/LoginPage'
import Header from './pages/common/Header'
import Footer from './pages/common/Footer'
import Error from './pages/error/Error'
import { useEffect, useState } from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'

function App() {
  const { messages } = useFetchMessages()
  let location = useLocation()

  const [authed, setAuthed] = useState(false)
  const [pageContent, setPageContent] = useState({})

  useEffect(() => {
    fetch('/careers-api/v1/user')
      .then((resp) => {
        if (resp.status >= 200 && resp.status <= 299) {
          return resp.json()
        } else {
          throw new Error(resp.statusText)
        }
      })
      .then((data) => {
        if (data) {
          setAuthed(data.user !== '')
        } else {
          setAuthed(false)
        }
      })
      .catch((error) => {
        console.log('error', error)
        setAuthed(false)
      })
  }, [])

  useEffect(() => {
    if (authed) {
      fetch('/careers-api/v1/internal/pageContent')
        .then((resp) => {
          if (resp.status >= 200 && resp.status <= 299) {
            return resp.json()
          } else {
            throw new Error(resp.statusText)
          }
        })
        .then((data) => {
          setPageContent(data)
        })
        .catch((error) => {
          console.log('error', error)
          setPageContent({})
        })
    } else {
      setPageContent({})
    }
  }, [authed])

  return (
    <>
      <Header authed={authed} />
      <Switch>
        <Route path='/inside-b-n'>
          <InsideBnPage authed={authed} />
        </Route>
        <Route path='/internal/inside-b-n'>
          <InsideBnInternalPage authed={authed} />
        </Route>
        <Route path='/locations'>
          <LocationsPage authed={authed} />
        </Route>
        <Route path='/retail-jobs'>
          <JobListingPage
            title='Retail Job'
            locationType='retail'
            message={messages && ['retail_page'] ? messages['retail_page'] : ''}
          />
        </Route>
        <Route path='/corporate-jobs'>
          <JobListingPage
            title='Corporate Job'
            locationType='corporate'
            message={
              messages && ['corporate_page'] ? messages['corporate_page'] : ''
            }
          />
        </Route>
        <Route path='/distribution-jobs'>
          <JobListingPage
            title='Distribution Job'
            locationType='dist_center'
            message={
              messages && messages['distribution_page']
                ? messages['distribution_page']
                : ''
            }
          />
        </Route>

        <Route path='/internal/testimonials'>
          <TestimonialsPage html={pageContent['testimonials']} />
        </Route>
        <Route path='/internal/retail-jobs'>
          <JobListingInternalPage
            title='Retail Job'
            locationType='retail'
            message={messages && ['retail_page'] ? messages['retail_page'] : ''}
            authed={authed}
            html={pageContent['retail']}
          />
        </Route>
        <Route path='/internal/home-office-jobs'>
          <JobListingInternalPage
            title='Home Office Job'
            locationType='corporate'
            message={
              messages && ['corporate_page'] ? messages['corporate_page'] : ''
            }
            authed={authed}
            html={pageContent['corporate']}
          />
        </Route>
        <Route path='/internal/distribution-jobs'>
          <JobListingInternalPage
            title='Distribution Job'
            locationType='dist_center'
            message={
              messages && messages['distribution_page']
                ? messages['distribution_page']
                : ''
            }
            authed={authed}
            html={pageContent['distribution']}
          />
        </Route>

        <Route path='/job/:titleAndId' component={JobDetailPage} />
        <Route
          path='/internal/job/:titleAndId'
          component={JobDetailInternalPage}
        />

        <Route path='/' exact>
          <HomePage authed={authed} />
        </Route>
        <Route path='/internal' exact>
          <HomeInternalPage authed={authed} html={pageContent['home']} />
        </Route>

        <Route path='/login' component={LoginPage} />
        <Route path='*' component={Error} />
      </Switch>
      <Footer />
    </>
  )
}

export default App
